import { placeRangeRadioFilters } from './radio-filters';

export const DEFAULT_PHRASES_LIBRARY_PLACE_RANGE_FILTER = 'top_1_1';

const placeRangeRadioFilterToPosition: Record<string, string | undefined> = {
  all: undefined,
  top_1_1: 'top1',
  top_2_5: 'top2-5',
  top_6_10: 'top6-10',
  top_11_50: 'top11-50',
  top_51_100: 'top51-100',
  top_101_500: 'top101-500',
};

const serverPlaceRangeKeyToKey = Object.values(placeRangeRadioFilters).reduce<
  Record<string, string>
>((acc, filter) => {
  acc[filter.serverKey] = filter.id;

  const normalizedServerKey =
    filter.serverKey === 'all' ? 'all' : filter.serverKey.replace(/^top/, 'top-');

  acc[normalizedServerKey] = filter.id;

  return acc;
}, {});

export const getPositionByPlaceRangeRadioFilter = (
  placeRangeRadioFilter: string,
): string | undefined => placeRangeRadioFilterToPosition[placeRangeRadioFilter];

export const getPlaceRangeRadioFilterByServerKey = (
  serverPlaceRangeKey: string,
): string | undefined => serverPlaceRangeKeyToKey[serverPlaceRangeKey];
